import type { CellEntry, TimepointCellEntry } from "@tento-lona/sheets";

import type { RowCellCache } from "../sync/row-cell-cache.ts";

/**
 * Untag the entries of a `RowCellCache.cellsIn` / `allCells` read back into the
 * per-lane shapes (`CellEntry` / `TimepointCellEntry`) older read sites return.
 * The `kind` tag is dropped so a returned entry compares equal to the stored
 * one.
 */
export namespace TaggedCells {
  /** The date-keyed (`kind: "date"`) entries, in read order. */
  export function dates(cells: readonly RowCellCache.Cell[]): CellEntry[] {
    const out: CellEntry[] = [];
    for (const cell of cells) {
      if (cell.kind !== "date") continue;
      const { kind: _kind, ...entry } = cell;
      out.push(entry);
    }
    return out;
  }

  /** The timepoint (`kind: "timepoint"`) entries, in read order. */
  export function customs(cells: readonly RowCellCache.Cell[]): TimepointCellEntry[] {
    const out: TimepointCellEntry[] = [];
    for (const cell of cells) {
      if (cell.kind !== "timepoint") continue;
      const { kind: _kind, ...entry } = cell;
      out.push(entry);
    }
    return out;
  }
}
